import type { ComponentPropsWithRef, ReactNode } from 'react';

import { Dialog as BaseDialog } from '@base-ui/react';
import { useTranslation } from 'react-i18next';

import { clsx } from '~/styles/utils';

import { Button } from '../Button/Button';
import { Title } from '../Title/Title';
import { closeButtonStyle, descriptionStyle, headerStyle, headerTextStyle, wrapperStyle } from './Dialog.css';

type Props = Omit<ComponentPropsWithRef<'div'>, 'title'> & {
  description?: ReactNode;
  hideCloseButton?: boolean;
  title?: ReactNode;
};

export const DialogHeader = ({ children, description, hideCloseButton = false, title, ...delegated }: Props) => {
  const { t } = useTranslation(['common']);

  return (
    <div {...delegated} className={clsx(headerStyle, delegated.className)}>
      <div className={wrapperStyle}>
        {(title || description) && (
          <div className={headerTextStyle}>
            {title && <BaseDialog.Title render={<Title as="h2" />}>{title}</BaseDialog.Title>}

            {description && <BaseDialog.Description className={descriptionStyle}>{description}</BaseDialog.Description>}
          </div>
        )}

        {children}
      </div>

      {!hideCloseButton && (
        <BaseDialog.Close render={<Button aria-label={t('common:actions.close')} className={closeButtonStyle} icon="CloseSmall" />} />
      )}
    </div>
  );
};
